// extracted by mini-css-extract-plugin
export default {"text":"kRltCiD5vkz_aghHi_et","green":"FftfU5opG7FERwYs6VMI","dark":"oomCvhfF1ZPxA6r1ld2g"};